const styles = ({ screenSizes, shadows, typography }) => ({
  boxShadow: shadows.dialog,
  maxHeight: '100%',
  maxWidth: 700,
  width: '100%',
  ...typography.p,
  ...typography.p2,

  [`@media(max-width: ${screenSizes.mobileMax}px)`]: {
    height: '100%',
  },
});

export default styles;
